var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.8 114.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.4,44.2h-.2c-7.2.1-13.1,5.9-13.1,13.1s5.8,13.2,13.1,13.3h.2c7.3-.1,13.1-6,13.1-13.3s-5.8-13-13.1-13.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.1,27.1h-33.4c-7.5,0-13.6,6.1-13.6,13.6v33.3c0,7.5,6.1,13.6,13.6,13.6h33.4c7.5,0,13.6-6.1,13.6-13.6v-33.3c0-7.5-6.1-13.6-13.6-13.6Zm-16.7,50.2h-.2c-11-.1-19.8-9-19.8-19.9s8.8-19.8,19.8-19.9h.2c11,.1,19.8,9,19.9,19.9,0,11-8.9,19.9-19.9,19.9Zm19.6-35.3c-2.3,0-4.2-1.8-4.2-4.1v-.1c0-2.3,1.8-4.2,4.1-4.2h.1c2.3,0,4.2,1.9,4.2,4.2s-1.8,4.1-4.2,4.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.4,0C25.7,0,0,25.7,0,57.4s25.7,57.4,57.4,57.4,57.4-25.7,57.4-57.4S89.1,0,57.4,0Zm36.6,74.2c0,10.9-8.9,19.7-19.8,19.7h-33.7c-10.9-.1-19.7-8.9-19.8-19.8v-33.5c.1-10.9,8.9-19.7,19.8-19.8h33.8c10.8,0,19.7,8.9,19.7,19.8v33.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagram-white.e230a4c2ff702cfbfcd9ea0fec70f86b.svg";
export { ForwardRef as ReactComponent };